module.exports = __webpack_public_path__ + "img/chest-bottom.69b34f65.svg";